module.exports = __webpack_public_path__ + "static/img/medal1.bb1c8d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1/medal1.png
// module id = Wq54
// module chunks = 1